import { BaseConfigControllerService, BaseMaterialListControllerService, FormSignProcessControllerService, VwVendorCountControllerService } from 'src/app/sdk/services';
import { Lb4ApiService } from 'src/app/shared/service/api/lb4-api.service';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DetailApplicationService } from '../../service/detail-application.service';
import { CommonService } from 'src/app/shared/service/common/common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-task-assign',
  templateUrl: './task-assign.component.html',
  styleUrls: ['./task-assign.component.scss']
})
export class TaskAssignComponent implements OnInit {
  @Input() taskAssignEdictStatus: boolean = false;
  @Input() taskAssignDisabled = false;
  @Input() formid: string;
  @Input() vendorTaskAssignEdictStatus = false;
  @Input() engineerTaskAssignEdictStatus = false;
  @Input() appAppointStatus: boolean;
  @Input() appointEditStatus;
  @Input() electromechanical: boolean;
  @Input() civilEngineering: boolean;
  @Input() edictData;
  @Input() getAssignPhone: string;
  @Output() submitTaskAssignDataEvent = new EventEmitter<object>();


  civilData = [];
  electromechanicalData = [];
  civilVendorInfoData = [];
  elecVendorInfoData = [];
  sendOrderData = [];//厂务工程师data
  facturerData = {};//选择厂商的data
  vendorInfoData = {};
  userid: string;
  projectData: string;
  projectItemInfo = {};//工程分类明细

  constructor(
    private lb4ApiService: Lb4ApiService,
    private baseConfigControllerService: BaseConfigControllerService,
    private vwVendorCountControllerService: VwVendorCountControllerService,
    private fromSignProcessService: FormSignProcessControllerService,
    private detailApplicationService: DetailApplicationService,
    private commonService: CommonService,
    private baseMaterialListControllerService: BaseMaterialListControllerService,
    private translateService: TranslateService,
  ) { }

  async ngOnInit() {
    await this.getInitDisplayTask();
    this.userid = localStorage.getItem('userid');

    this.detailApplicationService.civilOrElec.subscribe(res => {
      this.projectData = res;
      this.civilEngineering = this.projectData['civilEngineering'];
      this.electromechanical = this.projectData['electromechanical'];
      // 厂务课级签核时工程分类变更后重新初始化工程分类细项
      this.getInitElecOrCivilTypeData();
      // 厂务课级签核时工程分类变更后重新初始化选择厂商信息
      this.getInitFacturerData();
    })
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (this.electromechanical || this.civilEngineering) {
      await this.getInitElecOrCivilTypeData();
      await this.getInitAssignInvoiceData();
      await this.getInitFacturerData();
    }
  }

  // 获取工程分类明细数据
  async getInitElecOrCivilTypeData() {
    this.projectItemInfo = {};
    let projectInfo = {};
    // 在此组件中不限制目前已选的工程分类来获取工程分类明细信息,因为在edittable-task时可以修改工程分类
    const projectType = [
      { 'text': '土建类', 'value': 'civil' },
      { 'text': '机电类', 'value': 'electro' }
    ]
    // 获取料工清单的中类
    projectType.forEach(async arr => {
      await this.baseMaterialListControllerService.findMaterialData(
        {
          dbName: 'base_material_list',
          body: {
            where: { 'isvalid': 'Y', 'bigType': arr.text },
            columns: ['middleType']
          }
        }
      ).toPromise().then(res => {
        let resData = [];
        JSON.parse(JSON.stringify(res))['middleType'].forEach((item: string) => {
          resData.push({
            'middleType': item,
            'check': false
          });
        });
        projectInfo[arr.value] = resData;
      });
    });
    this.projectItemInfo = projectInfo;
  }

  // 派单厂务工程师信息:sendOrderData
  async getInitAssignInvoiceData() {
    //需要id
    let count = 0
    //需捕捉錯誤信息
    this.sendOrderData = await this.baseConfigControllerService.getSendOrdersInfoTest({ emplid: this.userid }).toPromise() as Array<any>;
    this.sendOrderData = this.sendOrderData.map(item => {
      item['id'] = count;
      item['formId'] = this.formid;
      count++;
      return item;
    });
  }

  // 获取vendor_info中的工程厂商信息:facturerData
  async getInitFacturerData() {
    this.facturerData = {};
    let tempFacturerData = {};
    await this.vwVendorCountControllerService.getVendorCounts({ dbName: "vendor_info" }).toPromise().then(res => {
      Object.keys(res).forEach(key => {
        for (let obj of res[key]) {
          obj['formId'] = this.formid;
          if (key === "civil") {
            obj['issuedTotal'] = obj['issuedBidTotal'];
            obj['issuedBidPer'] = obj['cissuedBidPer'];
            obj['issuedBidOverTimePer'] = obj['cissuedBidOverTimePer'];
            obj['notCooperateBidsPer'] = obj['cnotCooperateBidsPer'];
            obj['cicivlOrElectro'] = this.translateService.instant('DetailInfo.CIVIL');// 适应多国语言
            delete obj['cissuedBidPer'];
            delete obj['cissuedBidOverTimePer'];
            delete obj['cnotCooperateBidsPer'];
            this.countsAndProportion(obj);
          }
          if (key === "electro") {
            obj['issuedBidPer'] = obj['eissuedBidPer'];
            obj['issuedBidOverTimePer'] = obj['eissuedBidOverTimePer'];
            obj['notCooperateBidsPer'] = obj['enotCooperateBidsPer'];
            obj['cicivlOrElectro'] = this.translateService.instant('DetailInfo.ELECTRO');// 适应多国语言
            delete obj['eissuedBidPer'];
            delete obj['eissuedBidOverTimePer'];
            delete obj['enotCooperateBidsPer'];
            this.countsAndProportion(obj);
          }
        }
      });

      if (this.civilEngineering) {
        tempFacturerData['civil'] = res['civil'];
      }
      if (this.electromechanical) {
        tempFacturerData['electro'] = res['electro'];
      }
      this.facturerData = tempFacturerData;
    });
  }

  // 获取DB中已选择的工程分类明细 厂务工程师 厂商
  async getInitDisplayTask() {
    const maxVersionNum = await this.commonService.getMaxVersion(this.formid);
    // 工程分类明细 厂务工程师
    await this.fromSignProcessService.getVendorInfo({ formId: this.formid, version: maxVersionNum }).toPromise().then(async result => {
      this.vendorInfoData = result;
      // 厂商
      await this.lb4ApiService.find("vendor_info_option", { where: { formId: this.formid, version: maxVersionNum } }).then(res => {
        for (let obj of res) {
          obj['issuedTotal'] = obj['issuedBidTotal'];
          // 适应多国语言
          obj['vendor'] = obj['civilOrElectro'] === 0 ? this.translateService.instant('DetailInfo.CIVIL') : this.translateService.instant('DetailInfo.ELECTRO');
          this.countsAndProportion(obj);
        }
        this.vendorInfoData['vendorInfoo'] = res;
      });
    });
    return this.vendorInfoData;
  }

  countsAndProportion(obj: object) {
    // 年度已出标单数/总数/占比	
    obj['issuedBid'] = obj['issuedBid'] > 0 ? obj['issuedBid'] : 0;
    obj['issuedTotal'] = obj['issuedTotal'] > 0 ? obj['issuedTotal'] : 0;
    obj['issuedBidPer'] = isNaN(obj['issuedBid'] / obj['issuedTotal']) ? "0.00%" : Number(obj['issuedBid'] / obj['issuedTotal'] * 100).toFixed(2) + "%";

    // 年度未按时出标单数/总数/占比
    obj['issuedBidOverTime'] = obj['issuedBidOverTime'] > 0 ? obj['issuedBidOverTime'] : 0;
    obj['issuedBidOverTimeTotal'] = obj['issuedBidOverTimeTotal'] > 0 ? obj['issuedBidOverTimeTotal'] : 0;
    obj['issuedBidOverTimePer'] = isNaN(obj['issuedBidOverTime'] / obj['issuedBidOverTimeTotal']) ? "0.00%" : Number(obj['issuedBidOverTime'] / obj['issuedBidOverTimeTotal'] * 100).toFixed(2) + "%";

    // 年度未配合出标单数/总数/占比
    obj['notCooperateBids'] = obj['notCooperateBids'] > 0 ? obj['notCooperateBids'] : 0;
    obj['notCooperateBidsTotal'] = obj['notCooperateBidsTotal'] > 0 ? obj['notCooperateBidsTotal'] : 0;
    obj['notCooperateBidsPer'] = isNaN(obj['notCooperateBids'] / obj['notCooperateBidsTotal']) ? "0.00%" : Number(obj['notCooperateBids'] / obj['notCooperateBidsTotal'] * 100).toFixed(2) + "%";
  }
}
